import getCustomIcon from 'lib/seats/getCustomIcon';
import features from 'lib/common/features';

function generateIconMarkup(el, icon, coords, classNames, colourCode) {
  if (!icon) {
    return;
  }

  let bBox = icon.bBox;
  let dimensions = {
    x: coords.x - bBox.width / 2,
    y: coords.y - bBox.height / 2,
    width: bBox.width,
    height: bBox.height
  };

  let svgNs = 'http://www.w3.org/2000/svg';
  let parent = el.parentNode;

  // Create new group to position icon
  let newElement = document.createElementNS(svgNs, 'g');
  newElement.setAttribute(
    'transform',
    `translate(${dimensions.x}, ${dimensions.y})`
  );
  newElement.setAttribute(
    'class',
    `syos-custom-icon syos-custom-icon--${icon.name} ${classNames.join(' ')}`
  );

  // Transfer path data to new element
  let pathElement = document.createElementNS(svgNs, 'path');
  pathElement.setAttribute('d', icon.pathData);

  if (colourCode && features.isEnabled('seatColours')) {
    pathElement.setAttribute('style', `fill: ${colourCode}`);
  }

  // Create a transparent background element to increase hit area
  let rectElement = document.createElementNS(svgNs, 'rect');
  rectElement.setAttribute('fill', 'transparent');
  rectElement.setAttribute('width', dimensions.width);
  rectElement.setAttribute('height', dimensions.height);

  // Build the icon node
  newElement.appendChild(pathElement);
  newElement.appendChild(rectElement);

  // Append the new element to the parent
  parent.appendChild(newElement);

  return newElement;
}

export default function renderCustomIcon(iconId, el, classNames, colourCode) {
  let icon = getCustomIcon(iconId);
  let coords = { x: el.getAttribute('cx'), y: el.getAttribute('cy') };
  let d = el.getAttribute('d');
  if (d) {
    let splited = d.substr(1).split(',');
    if (splited.length > 1) {
      let size = parseFloat(splited[1].substr(splited[1].indexOf('c') + 1));
      coords.x = parseFloat(splited[0]);
      coords.y = parseFloat(splited[1]) + size;
    }
  }
  let newIcon = generateIconMarkup(el, icon, coords, classNames, colourCode);
  return newIcon;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/renderCustomIcon.js